(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-review"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReadMore(section) {
      const readMoreText = section.dataset.readMoreText || 'Ver mais';
      const readLessText = section.dataset.readLessText || 'Ver menos';

      section.querySelectorAll('.card-review__read-more').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const reviewText = btn.previousElementSibling;
          if (!reviewText) return;
          const expanded = reviewText.classList.contains('is-expanded');
          reviewText.classList.toggle('is-expanded', !expanded);
          btn.textContent = expanded ? readMoreText : readLessText;
        });
      });
    }

    document.querySelectorAll('.cards-review').forEach(initReadMore);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-blocks"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initControls(controls) {
    var ref = controls.dataset.carouselRef;
    var section = controls.closest('.ui-test-collection-blocks');
    if (!section) return;

    var slidesEl = section.querySelector(
      'slideshow-component[ref="' + ref + '"] slideshow-slides'
    );
    if (!slidesEl) return;

    var progressFill = controls.querySelector('.collection-blocks__progress-fill');
    var prevBtn = controls.querySelector('.collection-blocks__carousel-btn--prev');
    var nextBtn = controls.querySelector('.collection-blocks__carousel-btn--next');

    var getScrollAmount = function () {
      var slide = slidesEl.querySelector('slideshow-slide');
      if (!slide) return slidesEl.clientWidth;
      var gap = parseFloat(getComputedStyle(slidesEl).gap) || 0;
      return slide.offsetWidth + gap;
    };

    prevBtn.addEventListener('click', function () {
      slidesEl.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      slidesEl.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    var update = function () {
      var scrollMax = slidesEl.scrollWidth - slidesEl.clientWidth;
      prevBtn.disabled = slidesEl.scrollLeft <= 1;
      nextBtn.disabled =
        slidesEl.scrollLeft + slidesEl.clientWidth >= slidesEl.scrollWidth - 1;

      if (progressFill instanceof HTMLElement) {
        var thumbPct = (slidesEl.clientWidth / slidesEl.scrollWidth) * 100;
        var posPct =
          scrollMax > 0 ? (slidesEl.scrollLeft / scrollMax) * (100 - thumbPct) : 0;
        progressFill.style.width = thumbPct + '%';
        progressFill.style.left = posPct + '%';
      }
    };

    slidesEl.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(slidesEl);
    update();
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-carousel-controls]')
      .forEach(initControls);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
